import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AccountRoleService } from 'auth/account-role.service';
import { isArray } from 'lodash-es';
import { UserRole } from 'generated/graphql';

/**
 * Add the template content to the DOM unless the condition is true.
 */
// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[appIfInRole]' })
export class IfInRoleDirective {
  private hasView = false;

  constructor(
    private _templateRef: TemplateRef<any>,
    private _accountRoleService: AccountRoleService,
    private _viewContainer: ViewContainerRef
  ) { }

  @Input() set appIfInRole(role: UserRole[] | UserRole) {

    const arrayedRole = [].concat(role) as UserRole[];

    const hasRole = this._accountRoleService.userHasRole(...arrayedRole);
    if (hasRole && !this.hasView) {
      this._viewContainer.createEmbeddedView(this._templateRef);
      this.hasView = true;
    } else if (!hasRole && this.hasView) {
      this._viewContainer.clear();
      this.hasView = false;
    }
  }
}
